import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogisticaRoutingModule } from './logistica-routing.module';
import { LiberarCitaComponent } from './liberar-cita/liberar-cita.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConsultaReversionesOpComponent } from './consulta-reversiones-op/consulta-reversiones-op.component';
import { ConsultaHistorialCitaComponent } from './consulta-historial-cita/consulta-historial-cita.component';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { ConsultaHistorialComprometidaComponent } from './consulta-historial-comprometida/consulta-historial-comprometida.component';
import { CrearPoligonoComponent } from './crear-poligono/crear-poligono.component';
import { DialogComboCreationComponent } from './dialog-combo-creation/dialog-combo-creation.component';
import { ModalAlertasComponent } from './modal-alertas/modal-alertas.component';
import { ModalCapacidadDiasComponent } from './modal-capacidad-dias/modal-capacidad-dias.component';
import { ModalHistoricoPoligonoComponent } from './modal-historico-poligono/modal-historico-poligono.component';
import { ModalHistoricoGeografiaComponent } from './modal-historico-geografia/modal-historico-geografia.component';
import { ModalHistoricoCapacidadesComponent } from './modal-historico-capacidades/modal-historico-capacidades.component';
import { ModalHistoricoAlertasComponent } from './modal-historico-alertas/modal-historico-alertas.component';
import { ModalHistoricoMovimientosComponent } from './modal-historico-movimientos/modal-historico-movimientos.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DashboardPoligonoComponent } from './dashboard-poligono/dashboard-poligono.component';
import { HistorialAperturaCierreComponent } from './historial-apertura-cierre/historial-apertura-cierre.component';
import { EtiquetasTrazabilidadComponent } from './etiquetas-trazabilidad/etiquetas-trazabilidad.component';
import { GestionarOpsClientesComponent } from './gestionar-ops-clientes/gestionar-ops-clientes.component';
import { OpsSinPoligonoComponent } from './ops-sin-poligono/ops-sin-poligono.component';
import { ModalHistoricoEnvioDetalleComponent } from './modal-historico-envio-detalle/modal-historico-envio-detalle.component';
import { ModalGestionarServiciosDiaComponent } from './modal-gestionar-servicios-dia/modal-gestionar-servicios-dia.component';
import { QuePasaraComponent } from './liberar-cita/components/que-pasara/que-pasara.component';
import { FormularioLiberacionComponent } from './liberar-cita/components/formulario-liberacion/formulario-liberacion.component';

@NgModule({
  declarations: [
    LiberarCitaComponent,
    QuePasaraComponent,
    FormularioLiberacionComponent,
    ConsultaReversionesOpComponent,
    ConsultaHistorialCitaComponent,
    ConsultaHistorialComprometidaComponent,
    CrearPoligonoComponent,
    DialogComboCreationComponent,
    ModalAlertasComponent,
    ModalCapacidadDiasComponent,
    ModalHistoricoPoligonoComponent,
    ModalHistoricoGeografiaComponent,
    ModalHistoricoCapacidadesComponent,
    ModalHistoricoAlertasComponent,
    ModalHistoricoMovimientosComponent,
    DashboardPoligonoComponent,
    HistorialAperturaCierreComponent,
    EtiquetasTrazabilidadComponent,
    GestionarOpsClientesComponent,
    OpsSinPoligonoComponent,
    ModalHistoricoEnvioDetalleComponent,
    ModalGestionarServiciosDiaComponent
  ],
  imports: [
    CommonModule,
    LogisticaRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ImportsModule,
    MatSlideToggleModule
  ]
})
export class LogisticaModule { }